// @flow

import React, { Component } from 'react';
import styled from 'styled-components';
import ReactDOM from 'react-dom';

const OverlayBackground = styled.div`
  tab-index: 1;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
`;

type OverlayProps = {
  children: any,
  siblingId?: string, //id of a DOM element to which the overlay should be sibling -> which should overlay cover
  id: string,
};

export default class Overlay extends Component<OverlayProps> {
  root = {};
  element: HTMLElement;

  constructor(props: OverlayProps) {
    super(props);
    if (this.props.siblingId) {
      const sibling: HTMLElement | null = document.getElementById(
        this.props.siblingId
      );
      if (sibling) {
        this.root = sibling.parentElement;
      } else {
        throw new Error('Sibling not found');
      }
    } else {
      this.root = document.getElementsByTagName('BODY')[0];
    }

    this.element = document.createElement('div');
    this.element.id = this.props.id;
  }

  componentDidMount() {
    if (this.root) {
      this.root.appendChild(this.element);
    }
  }

  componentWillUnmount() {
    if (this.root) {
      this.root.removeChild(this.element);
    }
  }

  render() {
    if (this.root) {
      return ReactDOM.createPortal(
        <OverlayBackground>{this.props.children}</OverlayBackground>,
        this.element
      );
    } else {
      throw new Error('Parrent not found');
    }
  }
}
